// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__WcxnN","row":"Node_row__2_7ld","label":"Node_label__1S-Wk","footer":"Node_footer__2vxjR"};